
import {
    SELECT_REPORT,
    SET_GEOM_CONDITION,
    SET_IS_GEO_ACTIVE,
    SET_IS_VALID,
    SET_PARAM_VALUE
} from '../sagas/ui';

import { Log } from '../../core';
const log = Log.getLogger('MultiSceneForApp.print.reducer.ui');

const initialState = {
    geomCondition: null,
    isGeoActive: false,
    isValid: false,
    reportId: null,
    reportType: null,
    paramValues: {}
};

export function getGeomCondition(state) {
    return state.geomCondition;
}

export function getIsGeoActive(state) {
    return state.isGeoActive;
}

export function getIsValid(state) {
    return state.isValid;
}

export function getParamValues(state) {
    return state.paramValues;
}

export function getParamsForReport(state) {
    let params = {
        ...state.paramValues
    };
    if (state.isGeoActive && state.geomCondition) {
        params.geom = state.geomCondition.geometry;
    }
    return params;
}

export function getReportId(state) {
    return state.reportId;
}

function selectReport(state, action) {
    return {
        ...state,
        reportId: action.reportId,
        reportType: action.reportType,
        paramValues: {}
    };
}

function calculateIsValid(geomCondition, isGeoActive) {
    return (geomCondition && isGeoActive)
}

function setGeomCondition(state, action) {
    let geomCondition = (action.geometry)
        ? {
            geometry: action.geometry,
            condition: action.condition
        }
        : null;

    return {
        ...state,
        geomCondition: geomCondition,
        isValid: calculateIsValid(
            geomCondition, state.isGeoActive
        )
    };
}

function setIsGeoActive(state, action) {
    return {
        ...state,
        isGeoActive: action.active,
        isValid: calculateIsValid(
            state.geomCondition, action.active
        )
    };
}

function setIsValid(state, action) {
    return {
        ...state,
        isValid: action.isValid
    };
}

function setParamValue(state, action) {
    return {
        ...state,
        paramValues: {
            ...state.paramValues,
            [action.paramId]: action.value
        }
    }
}

function ui(state = initialState, action) {
    switch (action.type) {

        case SELECT_REPORT:
            return selectReport(state, action);

        case SET_GEOM_CONDITION:
            return setGeomCondition(state, action);

        case SET_IS_GEO_ACTIVE:
            return setIsGeoActive(state, action);

        case SET_IS_VALID:
                return setIsValid(state, action);

        case SET_PARAM_VALUE:
            return setParamValue(state, action);

        default:
            return state;
    }
}

export default ui;
